import {Endpoints} from '../../../../../globals/api/endpoints';

export class MiniMapEndpoints extends Endpoints {

  private static readonly MINI_MAPS = MiniMapEndpoints.VIEWER + '/mini-map';
  public static readonly MINI_MAP = MiniMapEndpoints.MINI_MAPS + '/' + MiniMapEndpoints.PROJECT_ID;
  public static readonly MINI_MAP_PREVIEW = MiniMapEndpoints.MINI_MAPS + '/' + MiniMapEndpoints.VERSION_ID + '/preview';
}
